import * as Sentry from "@sentry/react";
import { SENTRY_URL } from "./api/endpoints.constants";
Sentry.init({
  dsn: SENTRY_URL,
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});